const styles = {
  kpiRow: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 3,
    marginTop: 6,
    flexWrap: 'wrap',
  },
  // Covers the (hidden) cards so loading/error keep the row at the cards' real height.
  kpiOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 3,
  },
  kpiCard: {
    padding: 2,
    minWidth: 140,
  },
  kpiCardHidden: {
    visibility: 'hidden',
  },
  kpiValue: {
    fontWeight: 500,
  },
  kpiLabel: {
    color: 'text.secondary',
    marginTop: 0.5,
  },
} as const
export default styles
